import React, { useState, useEffect } from "react";
import "../../styles/MergedChargesTooltip.css";
import ImagePreviewModal from "./ImagePreviewModal";
import separate_invoice_step1 from "../../assets/MergedChargesFlow/step1-SeparateInvoice.png";
import mergedcharges_step6 from "../../assets/MergedChargesFlow/step-5.png";
import mergedcharges_step7 from "../../assets/MergedChargesFlow/step-6.png";
import separate_invoice_step4 from "../../assets/MergedChargesFlow/step4-SeparateInvoice.png";

const SeparateChargesTooltip = () => {

    const slides = [
        {
            title: "Separate Invoice Creation",
            desc: "Select individual jobs or line items to generate separate invoices instead of combining all charges into a single invoice.",
            img: separate_invoice_step1,
        },
        {
            title: "Enter Separate Invoice Details",
            desc: "Provide invoice-specific details such as remarks, billing nature, supply period, and backdated date for each selected invoice.",
            img: mergedcharges_step6,
        },
        {
            title: "Review & Submit Separate Invoices",
            desc: "Review all generated invoices, verify charge details, and submit to complete the separate invoice creation process.",
            img: mergedcharges_step7,
        },
        {
            title: "Separate Invoice Processing Completed",
            desc: "Selected jobs have been processed and separate invoices have been successfully generated and recorded.",
            img: separate_invoice_step4,
        }
    ];

    const [index, setIndex] = useState(0);
    const [paused, setPaused] = useState(false);
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);

    useEffect(() => {
        if (paused || isPreviewOpen) return;

        const timer = setInterval(() => {
            nextSlide();
        }, 2500);

        return () => clearInterval(timer);
    }, [paused, isPreviewOpen]);

    const prevSlide = () => {
        setIndex((prev) => (prev - 1 + slides.length) % slides.length);
    };

    const nextSlide = () => {
        setIndex((prev) => (prev + 1) % slides.length);
    };

    return (
        <>
            <div className="tooltip-carousel">
                <button className="carousel-arrow left" onClick={prevSlide}>‹</button>
                <button className="carousel-arrow right" onClick={nextSlide}>›</button>

                <div
                    className="carousel-track"
                    style={{ transform: `translateX(-${index * 100}%)` }}
                >
                    {slides.map((slide, i) => (
                        <div
                            key={i}
                            className={`carousel-slide ${i === index ? "carousel-slide-active" : ""
                                }`}
                        >
                            <img
                                src={slide.img}
                                alt={slide.title}
                                onMouseEnter={() => setPaused(true)}
                                onMouseLeave={() => setPaused(false)}
                                onClick={() => setIsPreviewOpen(true)}
                            />
                            <h6>{slide.title}</h6>
                            <p>{slide.desc}</p>
                        </div>
                    ))}
                </div>

                <div className="carousel-dots">
                    {slides.map((_, i) => (
                        <span
                            key={i}
                            className={i === index ? "dot active" : "dot"}
                            onClick={() => setIndex(i)}
                        />
                    ))}
                </div>
            </div>

            {isPreviewOpen && (
                <ImagePreviewModal
                    data={slides[index]}
                    onClose={() => setIsPreviewOpen(false)}
                    onPrev={prevSlide}
                    onNext={nextSlide}
                />
            )}
        </>
    )
}

export default SeparateChargesTooltip
